import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import { ITerm } from 'app_types/admin/term/term.types'
import React, { FC, useState } from 'react'
import { MdDelete, MdDragIndicator, MdEdit } from 'react-icons/md'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import TermForm from '../TermForm/TermForm';

import './TermAdminCard.scss'
import TermService from 'app_services/admin/term/termService';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import { DraggableProvided } from 'react-beautiful-dnd';

interface ITermAdminCardProps {
  term: ITerm
  provided: DraggableProvided
  onTermUpdated?: () => void
  onTermDeleted?: () => void
}

const TermAdminCard: FC<ITermAdminCardProps> = ({
  term,
  provided: { innerRef, draggableProps, dragHandleProps },
  onTermUpdated,
  onTermDeleted,
}) => {
  const [isEditTerm, setIsEditTerm] = useState<boolean>(false)
  const termService = new TermService()
  const screenNotification = new ScreenNotificationsUtil()

  const handleClickEdit = () => {
    setIsEditTerm(true)
  }

  const handleClickDelete = async () => {
    const confirm = await screenNotification.showAskDelete()
    if (confirm?.isConfirmed) {
      const response = await termService.delete({ id: term._id })
      if (response?.code === 200) {
        onTermDeleted && onTermDeleted()
      }
    }
  }

  const handleClickCancel = () => {
    setIsEditTerm(false)
  }

  const handleTermUpdated = () => {
    setIsEditTerm(false)
    onTermUpdated && onTermUpdated()
  }

  return (
    isEditTerm ? (
      <TermForm
        term={term}
        type={term.type}
        onCancel={handleClickCancel}
        onTermUpdated={handleTermUpdated}
      />
    ) : (
      <div
        className="term-admin-card--layout"
        ref={innerRef}
        {...draggableProps}
      >
        <div
          {...dragHandleProps}
          className='term-admin-card--draggable'
        >
          <MdDragIndicator />
        </div>
        <div>
          <LabelComponent>
            Nombre:
          </LabelComponent>
          <TextComponent color="black">
            {term.name}
          </TextComponent>
        </div>
        <div className="term-admin-card--actions">
          <TooltipComponent text="Editar">
            <div className='term-admin-card--icon' onClick={handleClickEdit}>
              <MdEdit size="24px" />
            </div>
          </TooltipComponent>
          <TooltipComponent text='Eliminar'>
            <div className='term-admin-card--icon' onClick={handleClickDelete}>
              <MdDelete size="24px" />
            </div>
          </TooltipComponent>
        </div>
      </div>
    )
  )
}

export default TermAdminCard
